'use client';

import { useEffect, useState } from 'react';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import Image from 'next/image';

import medprevPin from './assets/medprev-pin.png';
import { Location } from './location.component';

import { ContentContainer } from '@/components/ui/content-container.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { Card } from '@/components/ui/card.component';
import { useSearchParams } from '@/hooks/use-search-params.hook';
import { PersistedUserNavigationSearchParams } from '@/types/enums/persisted-user-navigation-search-params.enum';

export const BranchesNearYouSection = () => {
  const [noLocation, setNoLocation] = useState<boolean | null>(null);
  const { cidade } = useSearchParams([PersistedUserNavigationSearchParams.CIDADE]);

  useEffect(() => {
    setNoLocation(cidade === null);
  }, [cidade]);

  if (noLocation === null) {
    return null;
  }

  if (!noLocation) {
    return null;
  }

  return (
    <>
      {noLocation && (
        <ContentContainer className="my-10 xl:mb-0">
          <section
            data-testid={DataTestIdEnum.CITY_BRANCHES_NEAR_YOU_SECTION}
            className="flex flex-col gap-4"
          >
            <Typography
              variant={TypographyVariant.LARGE_SUBTITLE}
              className="font-bold text-center xl:text-start"
            >
              Encontre uma unidade perto de você
            </Typography>

            <Card className="flex flex-col xl:flex-row justify-center items-start xl:items-center gap-6 p-6">
              <Image
                src={medprevPin}
                height={206}
                alt="medprev pin"
                draggable={false}
                className="hidden xl:block"
              />

              <div className="flex flex-col items-start w-full">
                <Typography className="mb-2">Busque pela cidade, bairro ou rua</Typography>
                <Location
                  className="w-full"
                  shouldScrollToBranchesListOnSelection
                />
              </div>

              <Image
                src={medprevPin}
                height={206}
                alt="medprev pin"
                draggable={false}
                className="block xl:hidden self-center"
              />

              <div className="flex flex-col items-center justify-center w-full xl:basis-1/3 xl:mt-7">
                <Typography variant={TypographyVariant.MEDIUM_SUBTITLE} className="font-bold xl:text-center">
                  +100 unidades
                </Typography>
                <Typography>em todo Brasil</Typography>
              </div>
            </Card>
          </section>
        </ContentContainer>
      )}
    </>
  );
};
